import OrgIntersDadosGeraisContent from './components/dadosGerais';
import { OrgInterDadosGeraisProvider } from './context/dadosGeraisContext';

export default function OrgIntersDadosGerais() {
  return (
    <OrgInterDadosGeraisProvider>
      <OrgIntersDadosGeraisContent />
    </OrgInterDadosGeraisProvider>
  );
}
